import { Image } from '@src/quince-components/src'
import React from 'react'
import theme from '../styles/theme'

import styles from './scaled-image.module.scss'

const ScaledImage = ({
  fluid,
  backgroundColor = theme.colors.greyLighter,
  className,
  style,
  alt,
  loading = 'auto',
  fadeIn = false,
  useNative,
  quality,
  overrideMaxImageWidth1600,
}) => {
  return (
    <div style={style} className={`${styles.wrapper} ${className || ''}`}>
      <Image
        className={styles.styledImage}
        url={fluid.file.url}
        title={fluid.title}
        backgroundColor={backgroundColor}
        alt={alt || 'hero-image'}
        loading={loading}
        fadeIn={fadeIn}
        useNative={useNative}
        quality={quality}
        overrideMaxImageWidth1600={overrideMaxImageWidth1600}
      />
    </div>
  )
}

export default ScaledImage
